import { useNavigate, useParams } from 'react-router-dom';
import { ShopsList } from './ShopsList';

/**
 * Thin wrapper для маршрута `/paint/:globalId/shops` (Block 3 Phase 5).
 *
 * В отличие от `HandlesShopsRoute` / `DecorsShopsRoute`, URL **не содержит**
 * сегмента `:kind` — paint один домен per ADR-0010 §1. `subKind` hardcoded
 * как const literal `'paint'`. Декодирует globalId verbatim P-001 и
 * пробрасывает в shared-Container `<ShopsList />`.
 *
 * Per ADR-0007 — wrapper живёт рядом с Container, чтобы router.tsx остался
 * плоским списком роутов без inline-функций.
 */
export function PaintShopsRoute() {
  const navigate = useNavigate();
  const params = useParams<{ globalId: string }>();
  // react-router-dom v7 уже декодирует path params; повторный
  // decodeURIComponent ломается на Global_ID с `%` (URIError).
  const globalId = params.globalId ?? '';
  return (
    <ShopsList
      entityKind="paint"
      subKind="paint"
      globalId={globalId}
      onBackToCard={() => navigate(`/paint/${encodeURIComponent(globalId)}`)}
    />
  );
}
